"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fleet Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.195
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchlistDeviceApi = exports.WatchlistDeviceApiFactory = exports.WatchlistDeviceApiFp = exports.WatchlistDeviceApiAxiosParamCreator = exports.FleetMetricsApi = exports.FleetMetricsApiFactory = exports.FleetMetricsApiFp = exports.FleetMetricsApiAxiosParamCreator = exports.DeviceOnFarmApi = exports.DeviceOnFarmApiFactory = exports.DeviceOnFarmApiFp = exports.DeviceOnFarmApiAxiosParamCreator = exports.DeviceOffFarmApi = exports.DeviceOffFarmApiFactory = exports.DeviceOffFarmApiFp = exports.DeviceOffFarmApiAxiosParamCreator = exports.DeviceAlarmsApi = exports.DeviceAlarmsApiFactory = exports.DeviceAlarmsApiFp = exports.DeviceAlarmsApiAxiosParamCreator = exports.AlarmSettingsApi = exports.AlarmSettingsApiFactory = exports.AlarmSettingsApiFp = exports.AlarmSettingsApiAxiosParamCreator = exports.DeviceOnFarmStatusEnum = exports.DeviceOnFarmStateEnum = exports.DeviceOffFarmCheckpointEnum = exports.CollarTaskContextTypeEnum = exports.AlarmTypeEnum = exports.AlarmStateEnum = exports.AlarmSettingsTypeEnum = exports.AlarmSearchModeEnum = exports.AlarmFilterTypeEnum = exports.AlarmActionTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * Type of alarm action to be taken on active alarms.
 * @export
 * @enum {string}
 */
exports.AlarmActionTypeEnum = {
    SNOOZE: 'SNOOZE',
    REMOVE_ALARM: 'REMOVE_ALARM',
    REMOVE_BIT_ERROR_FAULT: 'REMOVE_BIT_ERROR_FAULT',
    RETURN_TO_HALTER: 'RETURN_TO_HALTER',
    RESET_DEVICE: 'RESET_DEVICE',
    POWER_OFF_DEVICE: 'POWER_OFF_DEVICE',
    CHANGE_FARM: 'CHANGE_FARM',
    DEPROVISION_DEVICE: 'DEPROVISION_DEVICE'
};
/**
 * Type of alarm filter to be taken on active alarms.
 * @export
 * @enum {string}
 */
exports.AlarmFilterTypeEnum = {
    HIDE: 'HIDE',
    SNOOZE: 'SNOOZE'
};
/**
 * Mode of the alarm search.
 * @export
 * @enum {string}
 */
exports.AlarmSearchModeEnum = {
    ALL: 'ALL',
    ACTION_REQUIRED: 'ACTION_REQUIRED',
    NON_ACTION_REQUIRED: 'NON_ACTION_REQUIRED'
};
/**
 * Type of the alarm settings.
 * @export
 * @enum {string}
 */
exports.AlarmSettingsTypeEnum = {
    ALARM_SETTINGS: 'ALARM_SETTINGS',
    SNOOZE_ALARM_SETTINGS: 'SNOOZE_ALARM_SETTINGS',
    GLOBAL_ALARM_SETTINGS: 'GLOBAL_ALARM_SETTINGS'
};
/**
 * State of the alarm, only ALARMED and RESOLVED will be published. UNKNOWN is used internally  to indicate that the state for the alarm has not been determined yet.
 * @export
 * @enum {string}
 */
exports.AlarmStateEnum = {
    ALARMED: 'ALARMED',
    RESOLVED: 'RESOLVED',
    UNKNOWN: 'UNKNOWN'
};
/**
 * Alarms to be kept track of in fleet.
 * @export
 * @enum {string}
 */
exports.AlarmTypeEnum = {
    ANY: 'ANY',
    BIT_ERROR: 'BIT_ERROR',
    DEVICE_LOW_BATTERY: 'DEVICE_LOW_BATTERY',
    DEVICE_OUT_OF_BATTERY: 'DEVICE_OUT_OF_BATTERY',
    COLLAR_OFF_COW: 'COLLAR_OFF_COW',
    COLLAR_FLIPPED: 'COLLAR_FLIPPED',
    COLLAR_FLIPPED_TOO_OFTEN: 'COLLAR_FLIPPED_TOO_OFTEN',
    COLLAR_BACKWARDS: 'COLLAR_BACKWARDS',
    COLLAR_TAGGED_OFF_BUT_HIGH_MOVEMENT: 'COLLAR_TAGGED_OFF_BUT_HIGH_MOVEMENT',
    COMMS_WIFI_BUT_NO_LORA: 'COMMS_WIFI_BUT_NO_LORA',
    COMMS_FLAKY_LORA_UNRESPONSIVENESS: 'COMMS_FLAKY_LORA_UNRESPONSIVENESS',
    COMMS_SETTINGS_SYNC_STALE: 'COMMS_SETTINGS_SYNC_STALE',
    LORA_UNRESPONSIVE: 'LORA_UNRESPONSIVE',
    LORA_FRAME_COUNTER_RESETTING: 'LORA_FRAME_COUNTER_RESETTING',
    LORA_FLAKY_CHECKINS: 'LORA_FLAKY_CHECKINS',
    COWG_HIGH_FAILED_SHOCK_RATE_100_PERCENT: 'COWG_HIGH_FAILED_SHOCK_RATE_100_PERCENT',
    POWER_HIGH_USAGE: 'POWER_HIGH_USAGE',
    POWER_EXCESS_CURRENT: 'POWER_EXCESS_CURRENT',
    POWER_BROKEN_GENERATION_CURRENT_SENSOR: 'POWER_BROKEN_GENERATION_CURRENT_SENSOR',
    POWER_BROKEN_LOAD_CURRENT_SENSOR: 'POWER_BROKEN_LOAD_CURRENT_SENSOR',
    POWER_INVALID_BATTERY: 'POWER_INVALID_BATTERY',
    POWER_UNREALISTIC_BATTERY: 'POWER_UNREALISTIC_BATTERY',
    POWER_LOW_SOLAR_GENERATION: 'POWER_LOW_SOLAR_GENERATION',
    POWER_NO_SOLAR_GENERATION: 'POWER_NO_SOLAR_GENERATION',
    POWER_BATTERY_RAPID_DEPLETION: 'POWER_BATTERY_RAPID_DEPLETION',
    FIRMWARE_EXTREME_AVERAGE_ODBA: 'FIRMWARE_EXTREME_AVERAGE_ODBA',
    FIRMWARE_EXCESS_ESTIMATION_CURRENT: 'FIRMWARE_EXCESS_ESTIMATION_CURRENT',
    FIRMWARE_FREQUENT_RESETTING: 'FIRMWARE_FREQUENT_RESETTING',
    FIRMWARE_CRASH_BOOT_EVENT: 'FIRMWARE_CRASH_BOOT_EVENT',
    FIRMWARE_POSITION_INVALID: 'FIRMWARE_POSITION_INVALID',
    FIRMWARE_WIFI_POSITION_INVALID: 'FIRMWARE_WIFI_POSITION_INVALID',
    HARDWARE_HIGH_SHOCK_CHARGE_FAILURE: 'HARDWARE_HIGH_SHOCK_CHARGE_FAILURE',
    DUTY_CYCLE_GPS_HIGH_TOO_HIGH: 'DUTY_CYCLE_GPS_HIGH_TOO_HIGH',
    DUTY_CYCLE_GPS_LOW_TOO_HIGH: 'DUTY_CYCLE_GPS_LOW_TOO_HIGH',
    DUTY_CYCLE_IMU_HIGH_TOO_HIGH: 'DUTY_CYCLE_IMU_HIGH_TOO_HIGH',
    DUTY_CYCLE_IMU_LOW_TOO_HIGH: 'DUTY_CYCLE_IMU_LOW_TOO_HIGH',
    DUTY_CYCLE_IPC_COMMS_TOO_HIGH: 'DUTY_CYCLE_IPC_COMMS_TOO_HIGH',
    DUTY_CYCLE_IPC_CORE_TOO_HIGH: 'DUTY_CYCLE_IPC_CORE_TOO_HIGH',
    DUTY_CYCLE_DATA_LOGGING_MODE_TOO_HIGH: 'DUTY_CYCLE_DATA_LOGGING_MODE_TOO_HIGH',
    DUTY_CYCLE_POWER_DRAIN_MODE_TOO_HIGH: 'DUTY_CYCLE_POWER_DRAIN_MODE_TOO_HIGH',
    DUTY_CYCLE_LORA_RX_TOO_HIGH: 'DUTY_CYCLE_LORA_RX_TOO_HIGH',
    DUTY_CYCLE_BLUETOOTH_TOO_HIGH: 'DUTY_CYCLE_BLUETOOTH_TOO_HIGH',
    DUTY_CYCLE_COMMS_TOO_HIGH: 'DUTY_CYCLE_COMMS_TOO_HIGH',
    DUTY_CYCLE_CORE_TOO_HIGH: 'DUTY_CYCLE_CORE_TOO_HIGH',
    DUTY_CYCLE_LED_TOO_HIGH: 'DUTY_CYCLE_LED_TOO_HIGH',
    DUTY_CYCLE_PIEZO_TOO_HIGH: 'DUTY_CYCLE_PIEZO_TOO_HIGH',
    DUTY_CYCLE_VIBE_TOO_HIGH: 'DUTY_CYCLE_VIBE_TOO_HIGH',
    DUTY_CYCLE_WIFI_TOO_HIGH: 'DUTY_CYCLE_WIFI_TOO_HIGH'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CollarTaskContextTypeEnum = {
    CALIBRATION: 'CALIBRATION',
    HARDWARE: 'HARDWARE',
    POWER: 'POWER',
    SHOCK: 'SHOCK',
    OTHER: 'OTHER'
};
/**
 * Checkpoints in the device lifecycle not related to being on farm.
 * @export
 * @enum {string}
 */
exports.DeviceOffFarmCheckpointEnum = {
    SERIAL_NUMBER_GENERATED: 'SERIAL_NUMBER_GENERATED',
    SHIPPED_FROM_FACTORY: 'SHIPPED_FROM_FACTORY',
    NEVER_LEFT_FACTORY: 'NEVER_LEFT_FACTORY',
    ARRIVED_AT_HALTER: 'ARRIVED_AT_HALTER',
    HALTER_SCRAP: 'HALTER_SCRAP',
    STARTED_PREP: 'STARTED_PREP',
    FAILED_PREP: 'FAILED_PREP',
    COMPLETED_PREP: 'COMPLETED_PREP',
    SHIPPED_TO_FARM: 'SHIPPED_TO_FARM',
    ARRIVED_AT_FARM: 'ARRIVED_AT_FARM',
    RETURNED_TO_HALTER: 'RETURNED_TO_HALTER',
    RETURNS_STORAGE: 'RETURNS_STORAGE',
    RETURNED_TO_FT: 'RETURNED_TO_FT',
    RETURNED_TO_IAC: 'RETURNED_TO_IAC',
    OFFICE_MISC: 'OFFICE_MISC',
    MALROSE_MISC: 'MALROSE_MISC',
    RESEARCH_AND_DEVELOPMENT: 'RESEARCH_AND_DEVELOPMENT',
    HASS_TESTING: 'HASS_TESTING',
    SCRAPPED: 'SCRAPPED',
    UNKNOWN: 'UNKNOWN'
};
/**
 * States of the device on farm. A more in-depth description can be found here https://miro.com/app/board/uXjVMTWRHZA=/.
 * @export
 * @enum {string}
 */
exports.DeviceOnFarmStateEnum = {
    ASSIGNED_ON_FARM: 'ASSIGNED_ON_FARM',
    SHIPPING: 'SHIPPING',
    PHYSICALLY_ON_FARM: 'PHYSICALLY_ON_FARM',
    ASSIGNED_ON_COW: 'ASSIGNED_ON_COW',
    USED: 'USED',
    OUT_OF_BATTERY: 'OUT_OF_BATTERY',
    FALLEN_OFF_COW: 'FALLEN_OFF_COW',
    LORA_UNRESPONSIVE: 'LORA_UNRESPONSIVE',
    FAULTY: 'FAULTY',
    IN_BARN: 'IN_BARN',
    OFF_PLATFORM: 'OFF_PLATFORM',
    POWERED_OFF: 'POWERED_OFF',
    SWAP_REQUESTED: 'SWAP_REQUESTED',
    DEPROVISIONED: 'DEPROVISIONED',
    HAS_TASK_TAKE_OFF_COW: 'HAS_TASK_TAKE_OFF_COW',
    HAS_TASK_PICK_UP_FROM_FARM: 'HAS_TASK_PICK_UP_FROM_FARM'
};
/**
 * Status of the device\'s lifecycle on farm. A more in-depth description can be found here https://miro.com/app/board/uXjVMTWRHZA=/.
 * @export
 * @enum {string}
 */
exports.DeviceOnFarmStatusEnum = {
    SHIPPED_TO_FARM: 'SHIPPED_TO_FARM',
    POWERED_OFF_SPARE: 'POWERED_OFF_SPARE',
    POWERED_ON_SPARE: 'POWERED_ON_SPARE',
    UNHEALTHY_SPARE: 'UNHEALTHY_SPARE',
    HEALTHY_ON_COW: 'HEALTHY_ON_COW',
    OFFLINE_ON_COW: 'OFFLINE_ON_COW',
    FAULTY_ON_COW: 'FAULTY_ON_COW',
    FALLEN_OFF_COW: 'FALLEN_OFF_COW',
    IN_BARN: 'IN_BARN',
    OFF_PLATFORM: 'OFF_PLATFORM',
    TO_BE_PICKED_UP: 'TO_BE_PICKED_UP',
    DEPROVISIONED: 'DEPROVISIONED'
};
/**
 * AlarmSettingsApi - axios parameter creator
 * @export
 */
var AlarmSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to delete a alarm settings.
         * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlarmSettings: function (iDeleteAlarmSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/alarms/settings/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeleteAlarmSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find alarm settings list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAlarmSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/alarms/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to create or update an alarm settings.
         * @param {IUpsertAlarmSettingsRequestDTO} [iUpsertAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAlarmSettings: function (iUpsertAlarmSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/alarms/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpsertAlarmSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AlarmSettingsApiAxiosParamCreator = AlarmSettingsApiAxiosParamCreator;
/**
 * AlarmSettingsApi - functional programming interface
 * @export
 */
var AlarmSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlarmSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to delete a alarm settings.
         * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlarmSettings: function (iDeleteAlarmSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAlarmSettings(iDeleteAlarmSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find alarm settings list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAlarmSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllAlarmSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to create or update an alarm settings.
         * @param {IUpsertAlarmSettingsRequestDTO} [iUpsertAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAlarmSettings: function (iUpsertAlarmSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertAlarmSettings(iUpsertAlarmSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AlarmSettingsApiFp = AlarmSettingsApiFp;
/**
 * AlarmSettingsApi - factory interface
 * @export
 */
var AlarmSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlarmSettingsApiFp)(configuration);
    return {
        /**
         * Endpoint to delete a alarm settings.
         * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlarmSettings: function (iDeleteAlarmSettingsRequestDTO, options) {
            return localVarFp.deleteAlarmSettings(iDeleteAlarmSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find alarm settings list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAlarmSettings: function (options) {
            return localVarFp.findAllAlarmSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to create or update an alarm settings.
         * @param {IUpsertAlarmSettingsRequestDTO} [iUpsertAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAlarmSettings: function (iUpsertAlarmSettingsRequestDTO, options) {
            return localVarFp.upsertAlarmSettings(iUpsertAlarmSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlarmSettingsApiFactory = AlarmSettingsApiFactory;
/**
 * AlarmSettingsApi - object-oriented interface
 * @export
 * @class AlarmSettingsApi
 * @extends {BaseAPI}
 */
var AlarmSettingsApi = /** @class */ (function (_super) {
    __extends(AlarmSettingsApi, _super);
    function AlarmSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to delete a alarm settings.
     * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmSettingsApi
     */
    AlarmSettingsApi.prototype.deleteAlarmSettings = function (iDeleteAlarmSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.AlarmSettingsApiFp)(this.configuration).deleteAlarmSettings(iDeleteAlarmSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find alarm settings list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmSettingsApi
     */
    AlarmSettingsApi.prototype.findAllAlarmSettings = function (options) {
        var _this = this;
        return (0, exports.AlarmSettingsApiFp)(this.configuration).findAllAlarmSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to create or update an alarm settings.
     * @param {IUpsertAlarmSettingsRequestDTO} [iUpsertAlarmSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmSettingsApi
     */
    AlarmSettingsApi.prototype.upsertAlarmSettings = function (iUpsertAlarmSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.AlarmSettingsApiFp)(this.configuration).upsertAlarmSettings(iUpsertAlarmSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlarmSettingsApi;
}(base_1.BaseAPI));
exports.AlarmSettingsApi = AlarmSettingsApi;
/**
 * DeviceAlarmsApi - axios parameter creator
 * @export
 */
var DeviceAlarmsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to create device alarm action.
         * @param {IDeviceAlarmActionRequestDTO} [iDeviceAlarmActionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAlarmAction: function (iDeviceAlarmActionRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/alarms/actions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceAlarmActionRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find action required device monitoring alarms by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActionRequiredDeviceMonitoringAlarmsByFarmId: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('findActionRequiredDeviceMonitoringAlarmsByFarmId', 'farmId', farmId);
                    localVarPath = "/fleet/devices/alarms/action-required/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find action required device alarms.
         * @param {string} [nextSerialNumber] Next serial number to fetch action required alarms from.
         * @param {boolean} [includeSnoozeFilter] If set to true, snooze alarm filter will be used to filter the action required alarms result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActionRequiredDeviceMonitoringAlarmsContexts: function (nextSerialNumber, includeSnoozeFilter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/alarms/action-required";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (nextSerialNumber !== undefined) {
                        localVarQueryParameter['nextSerialNumber'] = nextSerialNumber;
                    }
                    if (includeSnoozeFilter !== undefined) {
                        localVarQueryParameter['includeSnoozeFilter'] = includeSnoozeFilter;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find a list of device monitoring alarm group ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceMonitoringAlarmGroupIds: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/alarms/groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find device monitoring alarms context by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {AlarmSearchModeEnum} [searchMode] The mode of the alarm search. Default to ACTION_REQUIRED.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceMonitoringAlarmsContextBySerialNumber: function (serialNumber, searchMode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('findDeviceMonitoringAlarmsContextBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/fleet/devices/alarms/contexts/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (searchMode !== undefined) {
                        localVarQueryParameter['searchMode'] = searchMode;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to search device monitoring alarms contexts.
         * @param {ISearchDeviceMonitoringAlarmsContextsRequestDTO} [iSearchDeviceMonitoringAlarmsContextsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeviceMonitoringAlarmsContexts: function (iSearchDeviceMonitoringAlarmsContextsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/alarms/contexts/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSearchDeviceMonitoringAlarmsContextsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find device monitoring alarms contexts by group id.
         * @param {ISearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO} [iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeviceMonitoringAlarmsContextsByGroupId: function (iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/alarms/contexts/groups/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceAlarmsApiAxiosParamCreator = DeviceAlarmsApiAxiosParamCreator;
/**
 * DeviceAlarmsApi - functional programming interface
 * @export
 */
var DeviceAlarmsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceAlarmsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to create device alarm action.
         * @param {IDeviceAlarmActionRequestDTO} [iDeviceAlarmActionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAlarmAction: function (iDeviceAlarmActionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDeviceAlarmAction(iDeviceAlarmActionRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find action required device monitoring alarms by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActionRequiredDeviceMonitoringAlarmsByFarmId: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findActionRequiredDeviceMonitoringAlarmsByFarmId(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find action required device alarms.
         * @param {string} [nextSerialNumber] Next serial number to fetch action required alarms from.
         * @param {boolean} [includeSnoozeFilter] If set to true, snooze alarm filter will be used to filter the action required alarms result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActionRequiredDeviceMonitoringAlarmsContexts: function (nextSerialNumber, includeSnoozeFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findActionRequiredDeviceMonitoringAlarmsContexts(nextSerialNumber, includeSnoozeFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find a list of device monitoring alarm group ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceMonitoringAlarmGroupIds: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findDeviceMonitoringAlarmGroupIds(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find device monitoring alarms context by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {AlarmSearchModeEnum} [searchMode] The mode of the alarm search. Default to ACTION_REQUIRED.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceMonitoringAlarmsContextBySerialNumber: function (serialNumber, searchMode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findDeviceMonitoringAlarmsContextBySerialNumber(serialNumber, searchMode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to search device monitoring alarms contexts.
         * @param {ISearchDeviceMonitoringAlarmsContextsRequestDTO} [iSearchDeviceMonitoringAlarmsContextsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeviceMonitoringAlarmsContexts: function (iSearchDeviceMonitoringAlarmsContextsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchDeviceMonitoringAlarmsContexts(iSearchDeviceMonitoringAlarmsContextsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find device monitoring alarms contexts by group id.
         * @param {ISearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO} [iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeviceMonitoringAlarmsContextsByGroupId: function (iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchDeviceMonitoringAlarmsContextsByGroupId(iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceAlarmsApiFp = DeviceAlarmsApiFp;
/**
 * DeviceAlarmsApi - factory interface
 * @export
 */
var DeviceAlarmsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceAlarmsApiFp)(configuration);
    return {
        /**
         * Endpoint to create device alarm action.
         * @param {IDeviceAlarmActionRequestDTO} [iDeviceAlarmActionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAlarmAction: function (iDeviceAlarmActionRequestDTO, options) {
            return localVarFp.createDeviceAlarmAction(iDeviceAlarmActionRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find action required device monitoring alarms by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActionRequiredDeviceMonitoringAlarmsByFarmId: function (farmId, options) {
            return localVarFp.findActionRequiredDeviceMonitoringAlarmsByFarmId(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find action required device alarms.
         * @param {string} [nextSerialNumber] Next serial number to fetch action required alarms from.
         * @param {boolean} [includeSnoozeFilter] If set to true, snooze alarm filter will be used to filter the action required alarms result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActionRequiredDeviceMonitoringAlarmsContexts: function (nextSerialNumber, includeSnoozeFilter, options) {
            return localVarFp.findActionRequiredDeviceMonitoringAlarmsContexts(nextSerialNumber, includeSnoozeFilter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find a list of device monitoring alarm group ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceMonitoringAlarmGroupIds: function (options) {
            return localVarFp.findDeviceMonitoringAlarmGroupIds(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find device monitoring alarms context by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {AlarmSearchModeEnum} [searchMode] The mode of the alarm search. Default to ACTION_REQUIRED.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceMonitoringAlarmsContextBySerialNumber: function (serialNumber, searchMode, options) {
            return localVarFp.findDeviceMonitoringAlarmsContextBySerialNumber(serialNumber, searchMode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to search device monitoring alarms contexts.
         * @param {ISearchDeviceMonitoringAlarmsContextsRequestDTO} [iSearchDeviceMonitoringAlarmsContextsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeviceMonitoringAlarmsContexts: function (iSearchDeviceMonitoringAlarmsContextsRequestDTO, options) {
            return localVarFp.searchDeviceMonitoringAlarmsContexts(iSearchDeviceMonitoringAlarmsContextsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find device monitoring alarms contexts by group id.
         * @param {ISearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO} [iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeviceMonitoringAlarmsContextsByGroupId: function (iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options) {
            return localVarFp.searchDeviceMonitoringAlarmsContextsByGroupId(iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceAlarmsApiFactory = DeviceAlarmsApiFactory;
/**
 * DeviceAlarmsApi - object-oriented interface
 * @export
 * @class DeviceAlarmsApi
 * @extends {BaseAPI}
 */
var DeviceAlarmsApi = /** @class */ (function (_super) {
    __extends(DeviceAlarmsApi, _super);
    function DeviceAlarmsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to create device alarm action.
     * @param {IDeviceAlarmActionRequestDTO} [iDeviceAlarmActionRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.createDeviceAlarmAction = function (iDeviceAlarmActionRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).createDeviceAlarmAction(iDeviceAlarmActionRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find action required device monitoring alarms by farm id.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.findActionRequiredDeviceMonitoringAlarmsByFarmId = function (farmId, options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).findActionRequiredDeviceMonitoringAlarmsByFarmId(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find action required device alarms.
     * @param {string} [nextSerialNumber] Next serial number to fetch action required alarms from.
     * @param {boolean} [includeSnoozeFilter] If set to true, snooze alarm filter will be used to filter the action required alarms result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.findActionRequiredDeviceMonitoringAlarmsContexts = function (nextSerialNumber, includeSnoozeFilter, options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).findActionRequiredDeviceMonitoringAlarmsContexts(nextSerialNumber, includeSnoozeFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find a list of device monitoring alarm group ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.findDeviceMonitoringAlarmGroupIds = function (options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).findDeviceMonitoringAlarmGroupIds(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find device monitoring alarms context by serial number.
     * @param {string} serialNumber Unique serial number of the device.
     * @param {AlarmSearchModeEnum} [searchMode] The mode of the alarm search. Default to ACTION_REQUIRED.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.findDeviceMonitoringAlarmsContextBySerialNumber = function (serialNumber, searchMode, options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).findDeviceMonitoringAlarmsContextBySerialNumber(serialNumber, searchMode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to search device monitoring alarms contexts.
     * @param {ISearchDeviceMonitoringAlarmsContextsRequestDTO} [iSearchDeviceMonitoringAlarmsContextsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.searchDeviceMonitoringAlarmsContexts = function (iSearchDeviceMonitoringAlarmsContextsRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).searchDeviceMonitoringAlarmsContexts(iSearchDeviceMonitoringAlarmsContextsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find device monitoring alarms contexts by group id.
     * @param {ISearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO} [iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceAlarmsApi
     */
    DeviceAlarmsApi.prototype.searchDeviceMonitoringAlarmsContextsByGroupId = function (iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceAlarmsApiFp)(this.configuration).searchDeviceMonitoringAlarmsContextsByGroupId(iSearchDeviceMonitoringAlarmsContextsByGroupIdRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceAlarmsApi;
}(base_1.BaseAPI));
exports.DeviceAlarmsApi = DeviceAlarmsApi;
/**
 * DeviceOffFarmApi - axios parameter creator
 * @export
 */
var DeviceOffFarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to find the latest device checkpoints.
         * @param {IFindDeviceOffFarmCheckpointsRequestDTO} [iFindDeviceOffFarmCheckpointsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLatestOffFarmCheckpointsForDevices: function (iFindDeviceOffFarmCheckpointsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/off-farm/checkpoints/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFindDeviceOffFarmCheckpointsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to record a batch of devices reaching a scrap checkpoint from the factory.
         * @param {ISetDevicesFactoryScrapCheckpointReachedRequestDTO} [iSetDevicesFactoryScrapCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesFactoryScrapCheckpointReached: function (iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/off-farm/checkpoints/factory/scrap";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSetDevicesFactoryScrapCheckpointReachedRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to record the arrival of a batch of device boxes at a checkpoint, shipped to Halter.
         * @param {ISetDevicesHalterArrivalCheckpointReachedRequestDTO} [iSetDevicesHalterArrivalCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesHalterArrivalCheckpointReached: function (iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/off-farm/checkpoints/arrival";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSetDevicesHalterArrivalCheckpointReachedRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to record a batch of devices reaching a checkpoint.
         * @param {ISetDevicesOffFarmCheckpointReachedRequestDTO} [iSetDevicesOffFarmCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesOffFarmCheckpointReached: function (iSetDevicesOffFarmCheckpointReachedRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/off-farm/checkpoints";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSetDevicesOffFarmCheckpointReachedRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to record a batch of devices reaching a shipping from factory checkpoint.
         * @param {Array<ISetDevicesShippedFromFactoryCheckpointReachedRequestDTO>} [iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesShippedFromFactoryCheckpointReached: function (iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/off-farm/checkpoints/factory/shipped";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceOffFarmApiAxiosParamCreator = DeviceOffFarmApiAxiosParamCreator;
/**
 * DeviceOffFarmApi - functional programming interface
 * @export
 */
var DeviceOffFarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceOffFarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to find the latest device checkpoints.
         * @param {IFindDeviceOffFarmCheckpointsRequestDTO} [iFindDeviceOffFarmCheckpointsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLatestOffFarmCheckpointsForDevices: function (iFindDeviceOffFarmCheckpointsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findLatestOffFarmCheckpointsForDevices(iFindDeviceOffFarmCheckpointsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to record a batch of devices reaching a scrap checkpoint from the factory.
         * @param {ISetDevicesFactoryScrapCheckpointReachedRequestDTO} [iSetDevicesFactoryScrapCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesFactoryScrapCheckpointReached: function (iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setDevicesFactoryScrapCheckpointReached(iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to record the arrival of a batch of device boxes at a checkpoint, shipped to Halter.
         * @param {ISetDevicesHalterArrivalCheckpointReachedRequestDTO} [iSetDevicesHalterArrivalCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesHalterArrivalCheckpointReached: function (iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setDevicesHalterArrivalCheckpointReached(iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to record a batch of devices reaching a checkpoint.
         * @param {ISetDevicesOffFarmCheckpointReachedRequestDTO} [iSetDevicesOffFarmCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesOffFarmCheckpointReached: function (iSetDevicesOffFarmCheckpointReachedRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setDevicesOffFarmCheckpointReached(iSetDevicesOffFarmCheckpointReachedRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to record a batch of devices reaching a shipping from factory checkpoint.
         * @param {Array<ISetDevicesShippedFromFactoryCheckpointReachedRequestDTO>} [iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesShippedFromFactoryCheckpointReached: function (iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setDevicesShippedFromFactoryCheckpointReached(iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceOffFarmApiFp = DeviceOffFarmApiFp;
/**
 * DeviceOffFarmApi - factory interface
 * @export
 */
var DeviceOffFarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceOffFarmApiFp)(configuration);
    return {
        /**
         * Endpoint to find the latest device checkpoints.
         * @param {IFindDeviceOffFarmCheckpointsRequestDTO} [iFindDeviceOffFarmCheckpointsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLatestOffFarmCheckpointsForDevices: function (iFindDeviceOffFarmCheckpointsRequestDTO, options) {
            return localVarFp.findLatestOffFarmCheckpointsForDevices(iFindDeviceOffFarmCheckpointsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to record a batch of devices reaching a scrap checkpoint from the factory.
         * @param {ISetDevicesFactoryScrapCheckpointReachedRequestDTO} [iSetDevicesFactoryScrapCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesFactoryScrapCheckpointReached: function (iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options) {
            return localVarFp.setDevicesFactoryScrapCheckpointReached(iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to record the arrival of a batch of device boxes at a checkpoint, shipped to Halter.
         * @param {ISetDevicesHalterArrivalCheckpointReachedRequestDTO} [iSetDevicesHalterArrivalCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesHalterArrivalCheckpointReached: function (iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options) {
            return localVarFp.setDevicesHalterArrivalCheckpointReached(iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to record a batch of devices reaching a checkpoint.
         * @param {ISetDevicesOffFarmCheckpointReachedRequestDTO} [iSetDevicesOffFarmCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesOffFarmCheckpointReached: function (iSetDevicesOffFarmCheckpointReachedRequestDTO, options) {
            return localVarFp.setDevicesOffFarmCheckpointReached(iSetDevicesOffFarmCheckpointReachedRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to record a batch of devices reaching a shipping from factory checkpoint.
         * @param {Array<ISetDevicesShippedFromFactoryCheckpointReachedRequestDTO>} [iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDevicesShippedFromFactoryCheckpointReached: function (iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options) {
            return localVarFp.setDevicesShippedFromFactoryCheckpointReached(iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceOffFarmApiFactory = DeviceOffFarmApiFactory;
/**
 * DeviceOffFarmApi - object-oriented interface
 * @export
 * @class DeviceOffFarmApi
 * @extends {BaseAPI}
 */
var DeviceOffFarmApi = /** @class */ (function (_super) {
    __extends(DeviceOffFarmApi, _super);
    function DeviceOffFarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to find the latest device checkpoints.
     * @param {IFindDeviceOffFarmCheckpointsRequestDTO} [iFindDeviceOffFarmCheckpointsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOffFarmApi
     */
    DeviceOffFarmApi.prototype.findLatestOffFarmCheckpointsForDevices = function (iFindDeviceOffFarmCheckpointsRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceOffFarmApiFp)(this.configuration).findLatestOffFarmCheckpointsForDevices(iFindDeviceOffFarmCheckpointsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to record a batch of devices reaching a scrap checkpoint from the factory.
     * @param {ISetDevicesFactoryScrapCheckpointReachedRequestDTO} [iSetDevicesFactoryScrapCheckpointReachedRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOffFarmApi
     */
    DeviceOffFarmApi.prototype.setDevicesFactoryScrapCheckpointReached = function (iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceOffFarmApiFp)(this.configuration).setDevicesFactoryScrapCheckpointReached(iSetDevicesFactoryScrapCheckpointReachedRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to record the arrival of a batch of device boxes at a checkpoint, shipped to Halter.
     * @param {ISetDevicesHalterArrivalCheckpointReachedRequestDTO} [iSetDevicesHalterArrivalCheckpointReachedRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOffFarmApi
     */
    DeviceOffFarmApi.prototype.setDevicesHalterArrivalCheckpointReached = function (iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceOffFarmApiFp)(this.configuration).setDevicesHalterArrivalCheckpointReached(iSetDevicesHalterArrivalCheckpointReachedRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to record a batch of devices reaching a checkpoint.
     * @param {ISetDevicesOffFarmCheckpointReachedRequestDTO} [iSetDevicesOffFarmCheckpointReachedRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOffFarmApi
     */
    DeviceOffFarmApi.prototype.setDevicesOffFarmCheckpointReached = function (iSetDevicesOffFarmCheckpointReachedRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceOffFarmApiFp)(this.configuration).setDevicesOffFarmCheckpointReached(iSetDevicesOffFarmCheckpointReachedRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to record a batch of devices reaching a shipping from factory checkpoint.
     * @param {Array<ISetDevicesShippedFromFactoryCheckpointReachedRequestDTO>} [iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOffFarmApi
     */
    DeviceOffFarmApi.prototype.setDevicesShippedFromFactoryCheckpointReached = function (iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceOffFarmApiFp)(this.configuration).setDevicesShippedFromFactoryCheckpointReached(iSetDevicesShippedFromFactoryCheckpointReachedRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceOffFarmApi;
}(base_1.BaseAPI));
exports.DeviceOffFarmApi = DeviceOffFarmApi;
/**
 * DeviceOnFarmApi - axios parameter creator
 * @export
 */
var DeviceOnFarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to find the device on farm states by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceOnFarmStatesBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('findDeviceOnFarmStatesBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/fleet/devices/on-farm/states/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find device on farm status count for a farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceOnFarmStatusCountsByFarmId: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('findDeviceOnFarmStatusCountsByFarmId', 'farmId', farmId);
                    localVarPath = "/fleet/devices/on-farm/status/farm/{farmId}/device-count"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find the device on farm states.
         * @param {IFindDeviceOnFarmStatesRequestDTO} [iFindDeviceOnFarmStatesRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnFarmStatesForDevices: function (iFindDeviceOnFarmStatesRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/on-farm/states/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFindDeviceOnFarmStatesRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceOnFarmApiAxiosParamCreator = DeviceOnFarmApiAxiosParamCreator;
/**
 * DeviceOnFarmApi - functional programming interface
 * @export
 */
var DeviceOnFarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceOnFarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to find the device on farm states by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceOnFarmStatesBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findDeviceOnFarmStatesBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find device on farm status count for a farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceOnFarmStatusCountsByFarmId: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findDeviceOnFarmStatusCountsByFarmId(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find the device on farm states.
         * @param {IFindDeviceOnFarmStatesRequestDTO} [iFindDeviceOnFarmStatesRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnFarmStatesForDevices: function (iFindDeviceOnFarmStatesRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findOnFarmStatesForDevices(iFindDeviceOnFarmStatesRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceOnFarmApiFp = DeviceOnFarmApiFp;
/**
 * DeviceOnFarmApi - factory interface
 * @export
 */
var DeviceOnFarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceOnFarmApiFp)(configuration);
    return {
        /**
         * Endpoint to find the device on farm states by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceOnFarmStatesBySerialNumber: function (serialNumber, options) {
            return localVarFp.findDeviceOnFarmStatesBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find device on farm status count for a farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDeviceOnFarmStatusCountsByFarmId: function (farmId, options) {
            return localVarFp.findDeviceOnFarmStatusCountsByFarmId(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find the device on farm states.
         * @param {IFindDeviceOnFarmStatesRequestDTO} [iFindDeviceOnFarmStatesRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnFarmStatesForDevices: function (iFindDeviceOnFarmStatesRequestDTO, options) {
            return localVarFp.findOnFarmStatesForDevices(iFindDeviceOnFarmStatesRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceOnFarmApiFactory = DeviceOnFarmApiFactory;
/**
 * DeviceOnFarmApi - object-oriented interface
 * @export
 * @class DeviceOnFarmApi
 * @extends {BaseAPI}
 */
var DeviceOnFarmApi = /** @class */ (function (_super) {
    __extends(DeviceOnFarmApi, _super);
    function DeviceOnFarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to find the device on farm states by serial number.
     * @param {string} serialNumber Unique serial number of the device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOnFarmApi
     */
    DeviceOnFarmApi.prototype.findDeviceOnFarmStatesBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceOnFarmApiFp)(this.configuration).findDeviceOnFarmStatesBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find device on farm status count for a farm.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOnFarmApi
     */
    DeviceOnFarmApi.prototype.findDeviceOnFarmStatusCountsByFarmId = function (farmId, options) {
        var _this = this;
        return (0, exports.DeviceOnFarmApiFp)(this.configuration).findDeviceOnFarmStatusCountsByFarmId(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find the device on farm states.
     * @param {IFindDeviceOnFarmStatesRequestDTO} [iFindDeviceOnFarmStatesRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceOnFarmApi
     */
    DeviceOnFarmApi.prototype.findOnFarmStatesForDevices = function (iFindDeviceOnFarmStatesRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceOnFarmApiFp)(this.configuration).findOnFarmStatesForDevices(iFindDeviceOnFarmStatesRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceOnFarmApi;
}(base_1.BaseAPI));
exports.DeviceOnFarmApi = DeviceOnFarmApi;
/**
 * FleetMetricsApi - axios parameter creator
 * @export
 */
var FleetMetricsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to record a batch of fleet metrics data.
         * @param {Array<IFleetMetricDTO>} [iFleetMetricDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFleetMetrics: function (iFleetMetricDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/metrics";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFleetMetricDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FleetMetricsApiAxiosParamCreator = FleetMetricsApiAxiosParamCreator;
/**
 * FleetMetricsApi - functional programming interface
 * @export
 */
var FleetMetricsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FleetMetricsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to record a batch of fleet metrics data.
         * @param {Array<IFleetMetricDTO>} [iFleetMetricDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFleetMetrics: function (iFleetMetricDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveFleetMetrics(iFleetMetricDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FleetMetricsApiFp = FleetMetricsApiFp;
/**
 * FleetMetricsApi - factory interface
 * @export
 */
var FleetMetricsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FleetMetricsApiFp)(configuration);
    return {
        /**
         * Endpoint to record a batch of fleet metrics data.
         * @param {Array<IFleetMetricDTO>} [iFleetMetricDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFleetMetrics: function (iFleetMetricDTO, options) {
            return localVarFp.saveFleetMetrics(iFleetMetricDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FleetMetricsApiFactory = FleetMetricsApiFactory;
/**
 * FleetMetricsApi - object-oriented interface
 * @export
 * @class FleetMetricsApi
 * @extends {BaseAPI}
 */
var FleetMetricsApi = /** @class */ (function (_super) {
    __extends(FleetMetricsApi, _super);
    function FleetMetricsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to record a batch of fleet metrics data.
     * @param {Array<IFleetMetricDTO>} [iFleetMetricDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetMetricsApi
     */
    FleetMetricsApi.prototype.saveFleetMetrics = function (iFleetMetricDTO, options) {
        var _this = this;
        return (0, exports.FleetMetricsApiFp)(this.configuration).saveFleetMetrics(iFleetMetricDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FleetMetricsApi;
}(base_1.BaseAPI));
exports.FleetMetricsApi = FleetMetricsApi;
/**
 * WatchlistDeviceApi - axios parameter creator
 * @export
 */
var WatchlistDeviceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to delete a watchlist device by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWatchlistDeviceBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('deleteWatchlistDeviceBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/fleet/devices/watchlist/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to find watchlist devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWatchlistDevices: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/watchlist";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to create or update a watchlist device.
         * @param {IUpsertWatchlistDeviceRequestDTO} [iUpsertWatchlistDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWatchlistDevice: function (iUpsertWatchlistDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fleet/devices/watchlist";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpsertWatchlistDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WatchlistDeviceApiAxiosParamCreator = WatchlistDeviceApiAxiosParamCreator;
/**
 * WatchlistDeviceApi - functional programming interface
 * @export
 */
var WatchlistDeviceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WatchlistDeviceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to delete a watchlist device by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWatchlistDeviceBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteWatchlistDeviceBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to find watchlist devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWatchlistDevices: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllWatchlistDevices(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to create or update a watchlist device.
         * @param {IUpsertWatchlistDeviceRequestDTO} [iUpsertWatchlistDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWatchlistDevice: function (iUpsertWatchlistDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertWatchlistDevice(iUpsertWatchlistDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WatchlistDeviceApiFp = WatchlistDeviceApiFp;
/**
 * WatchlistDeviceApi - factory interface
 * @export
 */
var WatchlistDeviceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WatchlistDeviceApiFp)(configuration);
    return {
        /**
         * Endpoint to delete a watchlist device by serial number.
         * @param {string} serialNumber Unique serial number of the device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWatchlistDeviceBySerialNumber: function (serialNumber, options) {
            return localVarFp.deleteWatchlistDeviceBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to find watchlist devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWatchlistDevices: function (options) {
            return localVarFp.findAllWatchlistDevices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to create or update a watchlist device.
         * @param {IUpsertWatchlistDeviceRequestDTO} [iUpsertWatchlistDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWatchlistDevice: function (iUpsertWatchlistDeviceRequestDTO, options) {
            return localVarFp.upsertWatchlistDevice(iUpsertWatchlistDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WatchlistDeviceApiFactory = WatchlistDeviceApiFactory;
/**
 * WatchlistDeviceApi - object-oriented interface
 * @export
 * @class WatchlistDeviceApi
 * @extends {BaseAPI}
 */
var WatchlistDeviceApi = /** @class */ (function (_super) {
    __extends(WatchlistDeviceApi, _super);
    function WatchlistDeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to delete a watchlist device by serial number.
     * @param {string} serialNumber Unique serial number of the device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistDeviceApi
     */
    WatchlistDeviceApi.prototype.deleteWatchlistDeviceBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.WatchlistDeviceApiFp)(this.configuration).deleteWatchlistDeviceBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to find watchlist devices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistDeviceApi
     */
    WatchlistDeviceApi.prototype.findAllWatchlistDevices = function (options) {
        var _this = this;
        return (0, exports.WatchlistDeviceApiFp)(this.configuration).findAllWatchlistDevices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to create or update a watchlist device.
     * @param {IUpsertWatchlistDeviceRequestDTO} [iUpsertWatchlistDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistDeviceApi
     */
    WatchlistDeviceApi.prototype.upsertWatchlistDevice = function (iUpsertWatchlistDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.WatchlistDeviceApiFp)(this.configuration).upsertWatchlistDevice(iUpsertWatchlistDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WatchlistDeviceApi;
}(base_1.BaseAPI));
exports.WatchlistDeviceApi = WatchlistDeviceApi;
